












import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

type DataTabItem = {
    text: string; value: string;
}
@Component
export default class Tabs extends Vue {
    @Prop({required: true, type: Array}) dataTabs!: DataTabItem[];
    @Prop(String) readonly selectedValue!: string;
    @Prop(String) readonly classPrefix?: string;

    select(tab: DataTabItem) {
        this.$emit('update:selectedValue', tab.value)
    }
}
